import React from "react";
import { useTranslation } from "react-i18next";
import TemplatePostsContainer from "app/components/TemplatePostsContainer";
import WorkflowPostingForm from "./WorkflowPostingForm";
import useWorkflowPostsModel from "./useWorkflowPostsModel";
import styles from "./styles.module.scss";

interface Props {
  templateId: string;
  onPostCreated?: () => void;
}

const WorkflowPostsConfig = ({ templateId, onPostCreated }: Props) => {
  const { t } = useTranslation();
  const {
    data,
    groupedPosts,
    pending,
    error,
    onPostDelete,
    onPostUpdate,
    onPostPin,
    onPost,
  } = useWorkflowPostsModel(templateId);

  return (
    <div className={styles.container}>
      <WorkflowPostingForm
        templateId={templateId}
        onPost={(post) => {
          onPost(post);
          onPostCreated?.();
        }}
      />
      {error ? (
        <div style={{ padding: 16, color: "#8c8c8c" }}>
          {t("Failed to load posts. Please try again.")}
        </div>
      ) : (
        <TemplatePostsContainer
          posts={data}
          groupedPosts={groupedPosts}
          onPostDelete={onPostDelete}
          onPostUpdate={onPostUpdate}
          onPostPin={onPostPin}
          pending={pending}
          hidePinBadge={false}
        />
      )}
    </div>
  );
};

export default WorkflowPostsConfig;
